import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import { ConfigurationList, ConfigurationRow } from "./ConfigurationList";import * as Screens from "src/screens";

const GET_USER_SETTINGS = gql`
  query GetUserSettings($customerid: uuid!, $userid: uuid!) {
    ums_usersettings(
      where: { customerid: { _eq: $customerid }, userid: { _eq: $userid } }
      order_by: { key: asc }
    ) {
      key
      value
    }
  }
`;

type RouteParams = { customerid: string; userid: string };
type GetUserSettingsData = { ums_usersettings: ConfigurationRow[] };
type GetUserSettingsVars = { customerid: string; userid: string };

const UserConfigurationsBase = () => {
  const { customerid, userid } = useParams<RouteParams>();
  const { navStore } = useContext(RootStoreContext);

  useEffect(() => {
    navStore.setTitle("Konfigurationen");
    navStore.setBackbutton(`/users/${customerid}/${userid}`, "Benutzer-Details");
  }, [navStore, customerid, userid]);

  const { data, loading, error } = useQuery<GetUserSettingsData, GetUserSettingsVars>(GET_USER_SETTINGS, {
    variables: { customerid, userid },
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  if (loading) return <Screens.Loading />;
  if (error) return <Screens.Error message={error.message} networkError={error.networkError} />;

  const rows = data?.ums_usersettings ?? [];

  return (
    <UI.Container className="pt-4">
      <UI.Row className="justify-content-md-center">
        <UI.Col md={8}>
          <UI.Card>
            <ConfigurationList configurations={rows} />
          </UI.Card>
        </UI.Col>
      </UI.Row>
    </UI.Container>
  );
};

export default Sentry.withProfiler(UserConfigurationsBase);
